import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import * as CommonConstants from '../utils/common.constants';

@Injectable()
export class DashboardService {
  constructor(private http: HttpClient) {
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }

  getPartnerCount() : Observable<any>{
   return this.http.get(CommonConstants.GET_PARTNER_TOTAL_COUNT).
   pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getTop5Partners(): Observable<any> {
    return this.http.get(CommonConstants.GET_TOP5_PARTNERS).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

  getPartnerCountByType(): Observable<any> {
    return this.http.get(CommonConstants.GET_PARTNER_COUNT_BY_TYPE).
      pipe(catchError((e: any) => throwError(this.errorHandler(e))));
  }

   errorHandler(error: any): void {
    throwError(error);
  };
}
